import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule, MenuIcon, SearchIcon } from 'lucide-angular';
import { GarageDropdownComponent } from '../garage-dropdown/garage-dropdown';
import { SearchBarComponent } from '../search-bar/search-bar';
import { CartMiniComponent } from '../../cart/cart-mini';

@Component({
  selector: 'allas-desktop-header',

  imports: [
    CommonModule,
    LucideAngularModule,
    GarageDropdownComponent,
    SearchBarComponent,
    CartMiniComponent,
  ],
  templateUrl: 'desktop-header.html',
})
export class DesktopHeaderComponent {
  @Input() searchQuery: string = '';
  @Output() searchChange = new EventEmitter<string>();
  @Output() toggleSidebar = new EventEmitter<void>();

  readonly menuIcon = MenuIcon;
  readonly searchIcon = SearchIcon;

  onSearchChange(event: any): void {
    this.searchChange.emit(event.target.value);
  }

  onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }
}
